export const PRODUCT_IMAGE_FORMATS = {
  LIST: 'list',
  PRODUCT: 'product',
  THUMBNAIL: 'thumbnail'
} as const;

export const PRODUCT_IMAGE_QUALIFIERS = {
  ANGLE: 'angle',
  FRONT: 'front'
} as const;
